// Flag home_continue_first: the phone Home leads with the video worked on last. Pure, so it's unit-tested
// (continue.test.ts).

type Dated = { id: string; channelId?: string | null; updatedAt?: string | null; createdAt?: string | null };

const when = (v: Dated) => {
  const t = Date.parse(v.updatedAt ?? v.createdAt ?? "");
  return Number.isFinite(t) ? t : 0;
};

/**
 * The video to continue: the most recently updated one in this channel (any channel when none of them is in it),
 * newest first; a video with no dates counts as oldest. Ties keep the list's order. Null when there are none.
 */
export function pickContinue<T extends Dated>(videos: readonly T[] | null | undefined, channelId?: string | null): T | null {
  if (!videos?.length) return null;
  const mine = channelId ? videos.filter((v) => v.channelId === channelId) : [];
  const pool = mine.length ? mine : videos;
  let best: T | null = null;
  for (const v of pool) if (!best || when(v) > when(best)) best = v;
  return best;
}

/** A next step worth a button on the Continue card (not "busy" or "nothing to do"). */
export const continueStep = <S extends { id: string; label: string }>(s: S | null | undefined): S | null => (s && s.label && s.id !== "busy" && s.id !== "none" ? s : null);
